import { LinkMouseEvent } from "../utils/analytics/types";

export type OverviewPageTranslatedContent = {
  greeting: string;
  currencyErrorBanner: string;
  headlineMetrics: {
    totalClients: string;
    totalEarnings: string;
    totalActiveClients: string;
    totalActiveClientsTooltip: string;
    fundedNotTraded: string;
    approvedNotFunded: string;
    period: string;
  };
  recentLeadsTranslatedTexts: {
    leadStatusMapping: Map<string, string>;
    goToLeads: string;
    header: string;
    clientIdColumn: string;
    nameColumn: string;
    createdColumn: string;
    statusColumn: string;
    noDataFound: string;
  };

  newClientsTranslatedTexts: {
    header: string;
    clientIdColumn: string;
    nameColumn: string;
    approvalDateColumn: string;
    noDataFound: string;
  };

  topEarnersTranslatedTexts: {
    viewMore: string;
    header: string;
    clientIdColumn: string;
    nameColumn: string;
    earningsColumn: string;
    noDataFound: string;
  };
};

export type OverviewPageAnalytics = {
  trackGoToLeadsEvent: (event: LinkMouseEvent) => void;
  trackGoToTopEarnersEvent: (event: LinkMouseEvent) => void;
  trackReferralCopyCodeEvent: (event: LinkMouseEvent) => void;
  trackRecentLeadStatusTooltipEvent: (
    status: string,
    isMobile: boolean,
  ) => void;
  trackOverviewTooltipEvent: (isMobile: boolean) => void;
};

export enum OverviewError {
  ConvertRateError = "convert_rate_error",
  NewClientError = "new_client_error",
  RecentLeadsError = "recent_leads_error",
}
